import {type LngLat, MapMarker} from '@yandex-delivery/blocks'
import React from 'react'

import {classes} from './PointPlacemark.classes'

type Props = {
  coords: LngLat
}

const PointPlacemark: React.FC<Props> = props => {
  return (
    <MapMarker coordinates={props.coords}>
      <div className={classes.root} />
    </MapMarker>
  )
}

export default PointPlacemark
